export default {
  category: {
    title: 'Article Category Management',
    addNew: 'Add Category',
    createTitle: 'Create Category',
    editTitle: 'Edit Category',
    form: {
      category: 'Category',
      categoryPlaceholder: 'Enter category name',
      categoryRequired: 'Please enter category name',
      language: 'Language',
      languagePlaceholder: 'Select language',
      languageRequired: 'Please select language',
      isActive: 'Active',
      isActivePlaceholder: 'Select status',
      name: 'Category Name',
      namePlaceholder: 'Enter category name',
      nameRequired: 'Please enter category name',
      slug: 'Slug',
      slugPlaceholder: 'Please enter slug',
      description: 'Description',
      descriptionPlaceholder: 'Enter category description',
      sortOrder: 'Sort Order',
      sortOrderPlaceholder: 'Lower numbers appear first',
      seoTitle: 'SEO Title',
      seoTitlePlaceholder: 'Enter SEO title',
      seoDescription: 'SEO Description',
      seoDescriptionPlaceholder: 'Enter SEO description',
      seoKeywords: 'SEO Keywords',
      seoKeywordsPlaceholder: 'Separate multiple keywords with commas',
      canonicalUrl: 'Canonical URL',
      canonicalUrlPlaceholder: 'Enter canonical URL',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Enter OG title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'Enter OG description',
      ogImage: 'OG Image',
      ogImagePlaceholder: 'Enter OG image URL',
    },
    table: {
      name: 'Category Name',
      slug: 'Slug',
      description: 'Description',
      language: 'Language',
      isActive: 'Status',
      sortOrder: 'Sort Order',
      updateTime: 'Updated At',
      action: 'Action',
    },
    tabs: {
      basic: 'Basic Info',
      seo: 'SEO Settings',
      og: 'OG Settings',
    },
  },
  tag: {
    title: 'Article Tag Management',
    addNew: 'Add Tag',
    createTitle: 'Create Tag',
    editTitle: 'Edit Tag',
    form: {
      tag: 'Tag',
      tagPlaceholder: 'Enter tag name',
      language: 'Language',
      languagePlaceholder: 'Select language',
      languageRequired: 'Please select language',
      isActive: 'Active',
      isActivePlaceholder: 'Select status',
      name: 'Tag Name',
      namePlaceholder: 'Enter tag name',
      nameRequired: 'Please enter tag name',
      slug: 'Slug',
      slugPlaceholder: 'Please enter slug',
      description: 'Description',
      descriptionPlaceholder: 'Enter tag description',
      seoTitle: 'SEO Title',
      seoTitlePlaceholder: 'Enter SEO title',
      seoDescription: 'SEO Description',
      seoDescriptionPlaceholder: 'Enter SEO description',
      seoKeywords: 'SEO Keywords',
      seoKeywordsPlaceholder: 'Separate multiple keywords with commas',
      canonicalUrl: 'Canonical URL',
      canonicalUrlPlaceholder: 'Enter canonical URL',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Enter OG title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'Enter OG description',
      ogImage: 'OG Image',
      ogImagePlaceholder: 'Enter OG image URL',
    },
    table: {
      name: 'Tag Name',
      slug: 'Slug',
      description: 'Description',
      isActive: 'Status',
      usageCount: 'Usage Count',
      updateTime: 'Updated At',
      action: 'Action',
    },
    tabs: {
      basic: 'Basic Info',
      seo: 'SEO Settings',
      og: 'OG Settings',
    },
  },
  article: {
    title: 'Article List Management',
    addNew: 'Add Article',
    createTitle: 'Create Article',
    editTitle: 'Edit Article',
    form: {
      keyword: 'Article title',
      keywordPlaceholder: 'Enter article title',
      category: 'Category',
      categoryPlaceholder: 'Select category',
      categoryRequired: 'Please select category',
      language: 'Language',
      languagePlaceholder: 'Select language',
      languageRequired: 'Please select language',
      status: 'Status',
      statusPlaceholder: 'Select status',
      dateRange: 'Published Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      title: 'Article Title',
      titlePlaceholder: 'Enter article title',
      titleRequired: 'Please enter article title',
      slug: 'Slug',
      slugPlaceholder: 'Please enter slug',
      summary: 'Summary',
      summaryPlaceholder: 'Enter article summary',
      content: 'Content',
      coverImage: 'Cover Image',
      coverImagePlaceholder: 'Enter cover image URL',
      publishedAt: 'Published At',
      tags: 'Tags',
      tagsPlaceholder: 'Select tags',
      sortOrder: 'Sort Order',
      sortOrderPlaceholder: 'Lower numbers appear first',
      isTop: 'Pin to Top',
      seoEnabled: 'Enable SEO',
      seoTitle: 'SEO Title',
      seoTitlePlaceholder: 'Enter SEO title',
      seoDescription: 'SEO Description',
      seoDescriptionPlaceholder: 'Enter SEO description',
      seoKeywords: 'SEO Keywords',
      seoKeywordsPlaceholder: 'Separate multiple keywords with commas',
      canonicalUrl: 'Canonical URL',
      canonicalUrlPlaceholder: 'e.g.: https://www.yoursite.com/article/Points/123',
      ogTitle: 'OG Title',
      ogTitlePlaceholder: 'Enter OG title',
      ogDescription: 'OG Description',
      ogDescriptionPlaceholder: 'Enter OG description',
      ogImage: 'OG Image',
      ogImagePlaceholder: 'Enter OG image URL',
    },
    table: {
      id: 'ID',
      article: 'Article',
      coreSeo: 'Core SEO',
      coverImage: 'Cover Image',
      socialOg: 'Social OG',
      isTop: 'Pin',
      status: 'Status',
      viewCount: 'Article Access Statistics (PV/UV)',
      action: 'Action',
      title: 'Title',
      category: 'Category',
      tags: 'Tags',
      language: 'Language',
      publisher: 'Publisher',
      updateTime: 'Updated Time',
      canonicalUrl: 'Canonical URL',
      seoKeywords: 'Keywords',
      dynamicParams: 'Dynamic Parameters',
      noImage: 'No Image',
      noOgImage: 'No OG Image',
      publishedAt: 'Published At',
    },
    status: {
      pending: 'Pending',
      published: 'Published',
      rejected: 'Rejected',
    },
      actions: {
        preview: 'Preview',
        edit: 'Edit',
        seoEdit: 'SEO Edit',
        delete: 'Delete',
        approve: 'Approve',
        reject: 'Reject',
        confirmApprove: 'Are you sure you want to approve this article?',
        confirmReject: 'Are you sure you want to reject this article?',
      },
      seoEdit: 'SEO & OG Edit',
    tabs: {
      basic: 'Basic Info',
      seo: 'SEO Settings',
      og: 'OG Settings',
    },
  },
  internalLink: {
    title: 'Internal Link Keyword Management',
    add: 'Add Keyword',
    edit: 'Edit Keyword',
    keyword: 'Keyword',
    keywordTag: 'Keyword Tag',
    keywordPlaceholder: 'Please enter keyword',
    url: 'URL',
    urlPlaceholder: 'Please enter URL',
    isBrand: 'Brand Term',
    maxReplacement: 'Max Replacement',
    maxReplacementPlaceholder: 'Enter max replacement count (Default: 5 for normal, 2 for brand)',
    isActive: 'Enabled',
  },
};

